import type { ZodIssue } from 'zod';
import type { PropertyCreateFormErrorKey, PropertyCreateFormErrors } from './types';

const FORM_ERROR_KEYS: PropertyCreateFormErrorKey[] = [
  'propertyCode',
  'submarket',
  'assetType',
  'totalRentableSf',
  'marketingSummary',
  'floorPlanMode',
  'floorPlanImageUrl',
  'streetNumber',
  'streetName',
  'streetType',
  'streetDirection',
  'suiteNumber',
  'city',
  'province',
  'postalCode',
];

const FORM_ERROR_KEY_SET = new Set(FORM_ERROR_KEYS);

export function isPropertyCreateFormErrorKey(value: unknown): value is PropertyCreateFormErrorKey {
  return typeof value === 'string' && FORM_ERROR_KEY_SET.has(value as PropertyCreateFormErrorKey);
}

function issuePathToField(path: (string | number)[]): PropertyCreateFormErrorKey | null {
  const [first, second] = path;
  if (first === 'address' && typeof second === 'string' && isPropertyCreateFormErrorKey(second)) {
    return second;
  }
  if (isPropertyCreateFormErrorKey(first)) {
    return first;
  }
  return null;
}

export function mapPropertyCreateIssues(issues: ZodIssue[]): PropertyCreateFormErrors {
  return issues.reduce<PropertyCreateFormErrors>((acc, issue) => {
    const field = issuePathToField(issue.path);
    if (field === null || typeof acc[field] === 'string') {
      return acc;
    }
    acc[field] = issue.message;
    return acc;
  }, {});
}
